module.exports = __webpack_public_path__ + "img/404-error.9b5fc5cc.jpg";